import type { ReactNode } from "react";

import { cn } from "./cn";

export function GroupLabel({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p
      className={cn(
        "text-caption font-semibold uppercase tracking-caps text-fg-subtle",
        className,
      )}
    >
      {children}
    </p>
  );
}
